import Header from '../components/Header'
import Footer from '../components/Footer'
import '../componentcss/About.css'
import Designer from '../images/Designer.png'



const About = () => {
    return (
        <div className ="about">
            < Header />
            <div className='about-main'>
                
                <div className='about-left'>
                    <img className=' responsive img-fluid designer-img designer-img-arch' src={Designer} alt="Stacy Rogers, founder and designer of SLR Couture"></img>
                </div>
                <span className='about-right'>
                    <div className='about-tagline'>Where Individuality Meets Couture</div>
                    SLR Couture is a Seattle based international design house specializing in bespoke luxury bridal and formal wear.
                    <br/>
                    <br/>
                    Founded in 2010 by designer Stacy Rogers, SLR Couture is rooted in expert craftsmanship, refined tailoring, and thoughtful attention to detail. Each garment is designed to enhance a woman's individual beauty, balancing sexy, classic, and chic elements with effortless elegance.
                    <br/>
                    <br/>
                    Inspired by the energy of a runway and the romance of Paris, SLR Couture creates modern, feminine designs with a subtle edge, crafted for women who value individuality, confidence, and impeccable fit.
                </span>
            </div>
            
            < Footer/>
        </div>
    )
}

export default About
